import styled from 'styled-components';

import Section from '../../atoms/Section/Section';
import FeaturePageBackground
  from '../../../assets/backgrounds/monochrome_shapes_background.svg';
import {maxMediaQueries, mediaQueries} from '../../utils/styling';
import ColoredShapesLight from '../../../assets/backgrounds/colored_shapes_background_light.svg';
import ColoredShapesDark from '../../../assets/backgrounds/colored_shapes_background_dark.svg';

export const HeroContainer = styled.div`
  padding: 0 128px;
  
  ${maxMediaQueries.sm`
      padding: 16px;
  `};
`;

export const HeroSectionLight = styled(Section)`
  padding: 56px 0;
  background-image: url(${FeaturePageBackground});
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  
  ${maxMediaQueries.sm`
      background-image: none;
  `};
`;

export const HeroSectionDark = styled('section')`
  position: relative;
  z-index: 1;
  margin-bottom: 50px;
  padding: ${({hasBackground}) => hasBackground ? '88px 0' : '72px 0 152px 0'};
  background-color: ${({theme}) => theme.colors.gray800};
  background-image: ${({hasBackground}) => hasBackground ? `url(${ColoredShapesDark})` : 'none'};
  background-size: 45%;
  background-position: right 30%;
  background-repeat: no-repeat;
  
  &::after {
    position: absolute;
    bottom: -48px;
    right: 0;
    left: 0;
    z-index: 0;
    content: '';
    border-bottom-left-radius: 50%;
    border-bottom-right-radius: 50%;
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    background-color: ${({theme}) => theme.colors.gray800};
  }
  
  h4 {
    margin-bottom: 48px;
  }
  
  ${maxMediaQueries.sm`
    padding: 24px 0 80px 0;
    background-image: none;
    
    h4 {
      margin-bottom: 24px;
    }
  `};
  
  ${mediaQueries.lg`
    background-size: 600px;
  `};
  
`;

export const HeroImageWrapper = styled.div`
  margin-right: -40px;
  
  .gatsby-image-wrapper {
    margin: auto;
    max-width: 410px;
  }
  
  ${maxMediaQueries.sm`
     margin: 48px 0 0 0;
  `};
`;
